import React, { useState, useEffect, useMemo } from "react";
import useMappedState from "@src/utils/useMappedState";
import history from "@src/utils/history";
import { Button, Modal, message, Tooltip, Spin } from "@cloud/atom-ui";
import RenderApiChart from "./apiList";
import {
  getScopeList,
  getCallBack,
  handleTenantInfo,
  getCommonPermission
} from "./thunk";
import webConfig from "@src/configs/web.config";
import * as css from "./style.module.less";
import SelectPersonComponent from "@src/components/SelectPersonComponent/index.tsx";
import { cmpSetting } from "./selectPersonSettings";
import { getLocalStorageWithExpire } from "@src/utils/common";
import QuestionCircleOutlined from "@cloud/atom-ui-icons/QuestionCircleOutlined";
import CommonHeader from "../../components/common-header";
import { getAppPathFromType, APP_TYPE } from "@src/utils/common";

export default props => {
  const { user, tenant } = useMappedState("root");
  const openAddress = /localhost/.test(window.location.hostname)
    ? location.origin
    : "";
  //appId   应用id
  //isvType 版本类型，1开发版，2体验版，0线上版
  //type 类型，1内部we码，2内部轻应用，3第三方we码，4第三方轻应用  5或9 无界面应用
  //appType 轻应用 7   we码 8  无界面应用 9
  const {
    history: {
      queryParams: {
        query: { id: appId, isvType = 1 }
      }
    }
  } = props;
  const {
    match: {
      params: { type }
    }
  } = props;
  // 应用信息
  const appInfo = getLocalStorageWithExpire("appInfo") || {};
  const appType =
    type == APP_TYPE.innerapp || type == 3
      ? 7
      : type == APP_TYPE.isv || type == 4
      ? 8
      : 9;
  //检查是否有权限操作
  let isDeveloper1 = false;
  if (user && user.roles && user.roles.length > 0) {
    isDeveloper1 = user.roles.find(
      obj =>
        obj.roleCode === "applicationsDeveloper" || //应用开发者
        obj.roleCode === "enterpriseAdmin" || //租户管理员
        (obj.roleCode === "appStoreAdmin" && user.isAllAppStoreAdmin) //企业应用管理员
    );
  } else {
    isDeveloper1 = true;
  }

  const [isDeveloper, setDeveloper] = useState(isDeveloper1); //是否有权限查看
  const [scopeList, setScopeList] = useState([]); //权限列表
  const canEdit = isvType == 1; //是否可修改,true可编辑，false不可编辑
  const [callBackUrl, setCallbackUrl] = useState(""); //回调地址
  const [tipModalVisible, setTipModalVisible] = useState(false);
  const [tipModal, setTipModal] = useState({ content: () => {}, footer: [] });
  const [tenantInfo, setTenantInfo] = useState(tenant);
  const [permissionData, setPermissionData] = useState({});
  const [permissionLoading, setPermissionLoading] = useState(false);
  const [permissionVisible, setPermissionVisible] = useState(false);
  const [permissionParam, setPermissionParam] = useState();
  const [permissionItem, setPermissionItem] = useState();
  const [permissionIndex, setPermissionIndex] = useState();

  // 获取数据范围权限
  const getPermission = tenantInfo => {
    setPermissionLoading(true);
    const params = {
      tenantId: tenantInfo?.tenantId,
      objectId: appId,
      namespace: "appaccess",
      action: "common-read",
      pageSize: 500,
      pageNum: 1
    };
    getCommonPermission(params)
      .then(res => {
        setPermissionData(res?.data || {});
        setPermissionLoading(false);
      })
      .catch(error => {
        setPermissionData({});
        setPermissionLoading(false);
        console.error(error);
      });
  };

  //获得数据
  useEffect(() => {
    handleTenantInfo().then(res => {
      if (res.status == 1) {
        setTenantInfo(res.data);
        isDeveloper && webConfig.DATARANGE && getPermission(res.data);
      }
    });

    //获得回调地址
    getCallBack(appId, getAppPathFromType(type)).then(res => {
      if (res.status === 1 && res.data?.callBackUrl) {
        setCallbackUrl(res.data?.callBackUrl);
      }
    });

    //获得权限列表
    isDeveloper &&
      getScopeList(appId, getAppPathFromType(type)).then(result => {
        if (result && result.status == 1) {
          let arr = {};
          let newArr = [];

          result.data.list.map(item => {
            if (item.chineseLabel in arr) {
              arr[item.chineseLabel].push(item);
            } else {
              arr[item.chineseLabel] = [item];
            }
          });
          for (const i in arr) {
            newArr.push({ subLable: i, list: arr[i] });
          }

          setScopeList(newArr);
        } else {
          localStorage.setItem(
            "appInfo",
            JSON.stringify({ appName: "", appId: "" })
          );
          history.push(`/${type}/wecode-v2`);
          message.error(result.errMsg);
        }
      });
  }, []);

  useEffect(() => {
    if (tenantInfo?.realNameAuth) {
      setTipModal({
        content: () => "当前租户已完成实名租户认证，可正常申请本API授权",
        footer: [
          <Button type="primary" onClick={handleTipModalCancel}>
            我知道了
          </Button>
        ]
      });
    } else {
      setTipModal({
        content: () => {
          return (
            <>
              请先完成{" "}
              <Button type="link" onClick={goToRealName} style={{ padding: 0 }}>
                租户实名认证
              </Button>{" "}
              方可申请该API权限，已经完成实名认证，直接刷新本页面
              <div style={{ textAlign: "right" }}>
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => goToRealName("guide")}
                >
                  实名认证帮助指导
                </Button>
              </div>
            </>
          );
        },
        footer: [
          <Button type="primary" onClick={goToRealName}>
            去实名认证
          </Button>,
          <Button type="default" onClick={handleTipModalCancel}>
            取消
          </Button>
        ]
      });
    }
  }, [tenantInfo]);

  const handleTipModalCancel = e => {
    setTipModalVisible(false);
  };

  const goToRealName = type => {
    if (type === "guide") {
      window.open(webConfig.realnameGuide, "_blank");
    } else {
      window.open(webConfig.toRealname, "_blank");
    }
    setTipModalVisible(false);
  };

  const updateScopeList = list => {
    setScopeList([...list]);
  };

  // 整理Tooltip内容
  const getTipsContent = () => {
    const { list = [], total = 0 } = permissionData;
    if (list[0]?.subjectType === "all-login-user" || list?.length === 0) {
      return "全体人员";
    } else {
      const nameList = [];
      list.forEach((item, index) => {
        if (index < 3) {
          nameList.push(item?.subjectName);
        }
      });
      const name = nameList.join(",").replace(/,$/gi, "");
      return total > 3 ? `${name}等${total}条数据` : `${name}`;
    }
  };

  const handleMainOk = data => {
    const _permissionData = { ...permissionData };
    _permissionData.list = data?.permission;
    _permissionData.total = (data?.permission && data?.permission?.length) || 0;
    setPermissionData({ ..._permissionData });
  };

  const onChangeOperation = (params, item, index) => {
    setPermissionParam(params);
    setPermissionItem(item);
    setPermissionIndex(index);
  };

  const handlePermissionVisible = () => {
    if (permissionParam.operation) {
      permissionParam.operation(permissionItem, permissionIndex);
    }
    setPermissionVisible(false);
  };

  return (
    <div>
      <CommonHeader title="权限管理" headerStyle={{ marginBottom: "19px" }} />
      <div style={{ marginBottom: "80px", position: "relative" }}>
        {/* 企业内部应用 */}
        {(type <= 2 || type == 5) && webConfig.DATARANGE && (
          <Spin spinning={permissionLoading}>
            <div className={css["range"]}>
              <div className={css["range-title"]}>数据范围</div>
              <div>
                用户可以申请权限，未设置数据范围的情况下，例如通讯录API默认允许访问所有人的数据，如果设置了数据范围为A部门，那么通讯录的API仅能访问A部门的数据。
              </div>
              <div style={{ margin: "5px 0" }}>
                约束：当前仅通讯录（新）API支持数据范围过滤，如果不设置则默认全员。
                <a
                  href={`https://${location.hostname}/docs/#/990hh0/whokyc/t1xdg4`}
                >
                  了解更多
                </a>
              </div>
              <div className={css["range-settings"]}>
                <span style={{ fontWeight: "bolder" }}>设置数据范围：</span>
                {Object.keys(permissionData).length ? (
                  <>
                    <span
                      style={{
                        marginRight: "5px",
                        background: "#eee",
                        padding: "0 5px",
                        borderRadius: "2px",
                        fontSize: "12px"
                      }}
                    >
                      {permissionData?.list &&
                      (permissionData?.list[0]?.subjectType ===
                        "all-login-user" ||
                        permissionData?.list?.length === 0)
                        ? "全员"
                        : "部分成员"}
                    </span>
                    <Tooltip
                      placement="top"
                      trigger="click"
                      title={() => {
                        return <div>{getTipsContent()}</div>;
                      }}
                    >
                      <QuestionCircleOutlined
                        style={{
                          marginLeft: "3px",
                          color: "#ccc",
                          fontSize: "16px",
                          cursor: "pointer"
                        }}
                      />
                    </Tooltip>
                    <SelectPersonComponent
                      name="sp-comp"
                      isDeveloper
                      handlePersonOk={handleMainOk}
                      params={{
                        appTag: {
                          // 调用设置可见范围的模块名或者应用名
                          objectId: appId,
                          tenantId: tenantInfo?.tenantId,
                          namespace: "appaccess",
                          objectName: `${appInfo?.nameZH}`,
                          action: "common-read"
                        },
                        isReverses: "2",
                        ...cmpSetting
                      }}
                    />
                  </>
                ) : null}
              </div>
            </div>
          </Spin>
        )}
        {isDeveloper &&
          scopeList &&
          scopeList.map((item, index) => {
            return (
              <RenderApiChart
                key={index}
                tenantInfo={tenantInfo}
                type={type}
                appType={appType}
                item={item}
                scopeList={scopeList}
                canEdit={canEdit}
                appId={appId}
                partId={index}
                eventCallBackUrl={callBackUrl}
                updateScopeList={updateScopeList}
                setTipModalVisible={setTipModalVisible}
                onPermissionCancel={() => setPermissionVisible(true)}
                onChangeOperation={onChangeOperation}
              />
            );
          })}

        <Modal
          destroyOnClose={true}
          title="缺少开发者角色"
          visible={!isDeveloper}
          width={400}
          onCancel={() => {
            type == 5
              ? history.go(-1)
              : history.push(
                  `/${type}/appdetailV2/editionManage?id=${appId}&type=${type}`
                );
          }}
          maskClosable={false}
          footer={[
            <Button
              key={0}
              type="primary"
              onClick={() => {
                type == 5
                  ? history.go(-1)
                  : history.push(
                      `/${type}/appdetailV2/editionManage?id=${appId}&type=${type}`
                    );
              }}
            >
              我知道了
            </Button>
          ]}
          className={css["modalShow"]}
        >
          <p className={css["modalCenter"]}>联系管理员添加开发者角色</p>
          <a
            href={`${openAddress}/docs/#/990hh0/whokyc/vwd3yr`}
            target="_blank"
            className={css["modalCenter"]}
          >
            【如何添加开发者角色】
          </a>
        </Modal>

        <Modal
          className={css["modalTip"]}
          title="提示"
          visible={tipModalVisible}
          width={400}
          height={224}
          onCancel={handleTipModalCancel}
          footer={tipModal.footer}
        >
          {tipModal.content()}
        </Modal>
        <Modal
          title="提示"
          className={css["modal-text-center"]}
          visible={permissionVisible}
          onOk={handlePermissionVisible}
          onCancel={() => setPermissionVisible(false)}
        >
          取消API权限可能影响API的使用
        </Modal>
      </div>
    </div>
  );
};
